import React from 'react';
import withTermsQuery from 'utils/withTermsQuery';

const PageJaunumi = (props) => {
  const PageWithTerms = withTermsQuery(
    'jaunumi',
    [
      'post_tag',
    ],
    props.lang,
    [
      'jaunumi',
      'temas',
      'visas_temas',
      'publicets',
      'atpakal',
      'talak',
      'no',

      'ieprieksejais_menesis',
      'nakamais_menesis',
      'janvaris',
      'februaris',
      'marts',
      'aprilis',
      'maijs',
      'junijs',
      'julijs',
      'augusts',
      'septembris',
      'oktobris',
      'novembris',
      'decembris',
      'svetdiena',
      'pirmdiena',
      'otrdiena',
      'tresdiena',
      'ceturtdiena',
      'piektdiena',
      'sestdiena',
      'sv',
      'pr',
      'ot',
      'tr',
      'ce',
      'pk',
      'se',

      'piem',
      'publicets_no',
      'publicets_lidz',
      'satur_vardus',
      'dzest'
    ]
  );
  return <PageWithTerms {...props} />
}

export default PageJaunumi;



// WEBPACK FOOTER //
// ./src/components/PageJaunumi.js